<!--
 * @Author: LHB
 * @Date: 2022-06-11 17:46:35
 * @LastEditTime: 2022-07-23 09:58:32
 * @LastEditors: LHB
 * @Description: 
 * @FilePath: \shirleyClass\src\modules\Bindwxerror\index.vue
 * ---
-->
<template>
  <div class="wrap">
    <div class="title title1">很抱歉，上课微信不对哦！</div>
    <div class="title title2">您的课程已经绑定在这个微信了哦：</div>
    <div class="info-box">
      <img class="avatar" :src="user.avatar" alt="" />
      <span class="name">{{ user.nickname }}</span>
    </div>
    <div class="waring-box">
      <div class="waring-title">
        请使用此微信登录课程平台上课，如需更换上课微信，
      </div>
      <div class="waring-title">
        可在<span class="waring-title1">雪梨英语课程平台-我的-更换上课微信</span
        >中更改
      </div>
    </div>
    <div class="tips-box">
      <div class="tips-left tips-item">
        <div class="tips-title">我的</div>
        <img
          class="tips-icon"
          src="../../assets/images/my_photo1@2x.png"
          alt=""
        />
      </div>
      <img
        class="setp-arrow"
        src="../../assets/images/step_line@2x.png"
        alt=""
      />
      <div class="tips-right tips-item">
        <div class="tips-title">更换上课微信</div>
        <img
          class="tips-icon"
          src="../../assets/images/gh_photo2@2x.png"
          alt=""
        />
      </div>
    </div>
    <div class="backBtn" @click="back">我知道了</div>
  </div>
</template>
<script>
import group from '../common/group'
import utils from '../../utils/index.js'
import wx_tools from '../common/wx_tools.js'

export default {
  name: 'bindwx',
  components: {},
  data() {
    return {
      user: {},
      token: '',
      tokenKey: 'tokenKey'
    }
  },
  mounted() {
    document.title = '雪梨英语'
    this.token = localStorage.getItem(this.tokenKey)
    this.getUser()
    this.initShare()
  },
  watch: {},
  methods: {
    getUser() {
      const params = { token: this.token }
      group.userGet
        .call(this, params)
        .then((res) => {
          console.log('bind-error', res)
          if (res.data.success) {
            this.user = res.data.data
            console.log('bind-error2', this.user)
          } else {
            this.$toast(res.data.error.msg)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    back() {
      this.$router.go(-1)
    },

    initShare() {
      console.log('调用initShare')
      const tempJumpLink = utils.config.config.shareUrl
      // 分享字数规则：主标题两行，副标题3行，超出全部...
      let shareObj = {
        debug: false,
        referer: tempJumpLink,
        appId: utils.config.config.appId,
        title: utils.config.config.shareMainTitle,
        desc: utils.config.config.shareDesTitle,
        link: tempJumpLink,
        imgUrl: utils.config.config.shareImgUrl,
        type: '', // 分享类型,music、video或link，不填默认为link
        dataUrl: '' // 如果type是music或video，则要提供数据链接，默认为空
        // success: this.shareSuccess
        // fail: this.shareFail
      }
      console.log('分享跳转地址--login', shareObj)
      wx_tools.initShare.call(this, shareObj)
    }
  }
}
</script>

<style src="./index.css" scoped></style>
